import { SET_USERLOGIN } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  const { payload, type } = action;

  switch (type) {
    case SET_USERLOGIN:
      return {
        ...state,
        userLogin: payload
      };
    default:
      return state;
  }
};
